/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsBlog = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsBlog = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_filter == true) {
      $('#blog_filter').on('change', function() {
        window.PXUTheme.jsBlog.blogFilter();
      });
    }

          // keeps tag filter highlighted after click
      let urlTagName = window.location.pathname.split("/");
      if (urlTagName.length != 3) {
        urlTagName = urlTagName.pop().replace(/[^a-zA-Z]/g, "");
        let tagElements = document.querySelectorAll(".tag");
        tagElements.forEach(function (element) {
          let anchor = element.querySelector("a");
          let elementTagName = anchor.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-zA-Z]/g, "");
          if (elementTagName === urlTagName) {
            anchor.parentElement.style.backgroundColor = "#981428";
            anchor.style.color = "white";
          }
        });
      }

  },
  blogFilter: function() {
    let url = $('#blog_filter').val();
    window.location = url;
  },
  unload: function($section) {
    $('#blog_filter').off();
  }
}

/******/ })()
;